import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import USPs from './components/USPs';
import Promos from './components/Promos';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import FloatingCallButton from '../../components/feature/FloatingCallButton';
import OurProcess from './components/OurProcess';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white pb-0 lg:pb-0">
      <Navbar />
      <Hero />
      <USPs />
      <Promos />
      <About />
      <Services />
      <OurProcess />
      <Testimonials />
      <Contact />
      <div className="pb-20 lg:pb-0">
        <Footer />
      </div>
      <FloatingCallButton />
    </div>
  );
}
